export default __webpack_public_path__ + "static/media/Handshake.b3cbc801.svg";